/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (locationWebsites) => ({
    type: actions.LOCATION_WEBSITES_RECEIVE,
    payload: { locationWebsites },
});